import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'ramda'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors, fontWeights } from '@/styles'
import { WarningLarge } from '@/components/icons'
import { usePersonaIdVerification } from '@/features/Persona'

const Wrapper = styled.div`
  padding: 50px 25px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const OriginalText = styled.p`
  margin: 8px 0 32px;
  text-align: center;
`

const Title = styled.span`
  margin-top: 20px;
  text-align: center;
  font-weight: ${fontWeights.bold};
  font-size: 20px;
`

const LearnMoreText = styled.a`
  margin-top: 20px;
  color: ${colors.link};
  text-decoration: none;
`

const VerificationModal = ({
  message,
  buttonText,
  business = false,
  history,
  title,
  learnMoreLink = ''
}) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const personaIdVerification = usePersonaIdVerification()

  const handleOnClick = () => {
    if (
      buttonText === t('b.components.view.got_it.button', 'Got it') ||
      buttonText === t('b.components.success_modal.ok.button', 'OK')
    ) {
      close()
    } else if (buttonText === 'Verify Now' && business) {
      history.replace('/profile')
      close()
    } else {
      personaIdVerification({})
      close()
    }
  }

  return (
    <Wrapper>
      <WarningLarge />
      {title && <Title>{title}</Title>}
      <OriginalText>{message}</OriginalText>
      <Button width={'100%'} theme="primary" onClick={handleOnClick}>
        {buttonText}
      </Button>
      {!isEmpty(learnMoreLink) && (
        <LearnMoreText href={learnMoreLink} target="_blank" rel="noopener noreferrer">
          {t('l.application.view.learn_more.button', 'Learn more')}
        </LearnMoreText>
      )}
    </Wrapper>
  )
}

export const showVerificationModal = createModal(VerificationModal)
